import React from 'react';
import ReactMarkdown from 'react-markdown';
import { HiOutlineDocumentText } from 'react-icons/hi';
import technicalDetailsMarkdown from '../../content/caHdForecastTechnicalDetails.md';

const CEC_HD_STOCK = [
    { year: 2027, stock: 2198 },
    { year: 2028, stock: 3223 },
    { year: 2029, stock: 5156 },
    { year: 2030, stock: 9447 },
];

const markdownComponents = {
    h1: ({ children }) => (
        <h1 className="text-3xl font-bold text-gray-800 mb-4 flex items-center gap-3">
            <div className="p-2 bg-blue-100 rounded-lg">
                <HiOutlineDocumentText size={24} className="text-blue-600" />
            </div>
            {children}
        </h1>
    ),
    h2: ({ children }) => (
        <h2 className="text-2xl font-semibold text-gray-800 mt-10 mb-4 border-b border-gray-200 pb-2">
            {children}
        </h2>
    ),
    h3: ({ children }) => (
        <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">
            {children}
        </h3>
    ),
    p: ({ children }) => (
        <p className="text-gray-600 leading-relaxed mb-4">
            {children}
        </p>
    ),
    strong: ({ children }) => (
        <strong className="font-semibold text-gray-800">{children}</strong>
    ),
    ul: ({ children }) => (
        <ul className="list-disc list-outside pl-6 text-gray-600 mb-4 space-y-2">
            {children}
        </ul>
    ),
    ol: ({ children }) => (
        <ol className="list-decimal list-outside pl-6 text-gray-600 mb-4 space-y-2">
            {children}
        </ol>
    ),
    li: ({ children }) => (
        <li className="text-gray-600 leading-relaxed">{children}</li>
    ),
    hr: () => (
        <hr className="my-8 border-gray-200" />
    ),
    a: ({ href, children }) => (
        <a
            href={href}
            className="text-blue-600 hover:text-blue-800 underline"
            target={href?.startsWith('http') ? '_blank' : undefined}
            rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
        >
            {children}
        </a>
    ),
};

function MarkdownBlock({ children }) {
    const text = String(children || '').trim();
    if (!text) return null;
    return (
        <ReactMarkdown components={markdownComponents}>
            {text}
        </ReactMarkdown>
    );
}

function CecStockTable() {
    return (
        <div className="my-6 overflow-x-auto rounded-lg border border-gray-200">
            <table className="min-w-full border-collapse text-left text-sm text-gray-700">
                <thead className="bg-gray-50">
                    <tr className="border-b border-gray-200">
                        <th className="px-4 py-2.5 font-semibold text-gray-800">Year</th>
                        <th className="px-4 py-2.5 font-semibold text-gray-800">CEC Class 7–8 electric truck stock</th>
                    </tr>
                </thead>
                <tbody>
                    {CEC_HD_STOCK.map((row) => (
                        <tr key={row.year} className="border-b border-gray-100 last:border-b-0">
                            <td className="px-4 py-2.5">{row.year}</td>
                            <td className="px-4 py-2.5">{row.stock.toLocaleString('en-US')}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

const CaStatewideTechnicalDetails = () => {
    const parts = String(technicalDetailsMarkdown || '').split('{{CEC_STOCK_TABLE}}');
    return (
        <div className="h-full overflow-y-auto bg-white">
            <div className="p-8 max-w-3xl mx-auto">
                <div className="prose prose-lg max-w-none">
                    <MarkdownBlock>{parts[0]}</MarkdownBlock>
                    {parts.length > 1 && <CecStockTable />}
                    <MarkdownBlock>{parts[1]}</MarkdownBlock>
                </div>
            </div>
        </div>
    );
};

export default CaStatewideTechnicalDetails;
